import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import forms from './forms'

const namespaced = true

const state = {
  data: {},
  memberships: {
    ids: [],
    index: {}
  },
  contentTree: {},
  contentTreeSaving: false,
  confirmationSent: false,
  fetchingMe: false,
  fetchingContentTree: false
}

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/index.js